import {ChangeDetectionStrategy, Component, inject, OnInit} from "@angular/core";
import {MatToolbar, MatToolbarRow} from "@angular/material/toolbar";
import {Title} from "@angular/platform-browser";
import {environment} from "@menu-environment";

@Component({
    selector: "app-environment-bar",
    imports: [
        MatToolbarRow,
        MatToolbar,
    ],
    templateUrl: "./environment-bar.component.html",
    styleUrl: "./environment-bar.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentBarComponent implements OnInit {
    protected readonly environment = environment;

    private readonly title = inject(Title);

    ngOnInit(): void {
        if (environment.environment !== "local" && environment.environment !== "prod") {
            this.title.setTitle(`${environment.environment.toUpperCase()} - ${this.title.getTitle()}`);
        }
    }
}
